"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RATING_FIELD_STAR = exports.RATING_FIELD_LABEL = void 0;
const RATING_FIELD_STAR = exports.RATING_FIELD_STAR = 'rating-field-star';
const RATING_FIELD_LABEL = exports.RATING_FIELD_LABEL = 'rating-field-label';
